<template>
<div>
    <banner
        v-for="(message, index) in undismissedMessages"
        :key="'notification-' + index"
        :title="getMessageTitle(message)"
        :description="getMessageDescription(message)"
        :link="getMessageLink(message)"
        :dismissible="message.dismissable"
        @close="dismiss(message)"
        :display="message.type"
    />
</div>
</template>

<script>
import * as alerts from '../services/AlertService';
import SvgIcon from './ui/SvgIcon.vue';
import Banner from "./ui/Banner.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";

export default {
    components: {
        Banner,
        'svg-icon': SvgIcon,
    },
    data: function () {
        return {
            messages: [],
            dismissedMessageIds: this.getDismissedMessageIds(),
        }
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        },
        undismissedMessages () {
            return this.messages.filter(message => {
                return !message.dismissable || !this.dismissedMessageIds.includes(message.id);
            });
        }
    },
    methods: {
        getMessageTitle(message) {
            let translation = message.translations.find(message => message.locale === this.locale);
            return translation ? translation.title ?? null : null;
        },
        getMessageDescription(message) {
            let translation = message.translations.find(message => message.locale === this.locale);
            return translation ? translation.content ?? null : null;
        },
        getMessageLink(message) {
            let translation = message.translations.find(message => message.locale === this.locale);
            return translation ? translation.link ?? null : null;
        },
        dismiss(message) {
            this.setDismissedMessageIds(this.dismissedMessageIds.concat([message.id]));
        },
        getDismissedMessageIds() {
            return window.localStorage.getItem('dismissedAlerts') || [];
        },
        setDismissedMessageIds(ids) {
            this.dismissedMessageIds = ids;
            window.localStorage.setItem('dismissedAlerts', ids);
        },
        fetchAlerts() {
            alerts.index().then(result => {
                this.messages = result;
            });
        }
    },
    mounted () {
        this.fetchAlerts();
        this.$interval = setInterval(() => {
            this.fetchAlerts();
        }, 6000000)
    },
    beforeUnmount () {
        if (this.$interval) {
            clearInterval(this.$interval);
        }
    }
}
</script>
